import { render, staticRenderFns } from "./PageInspiration.vue?vue&type=template&id=cdf9b47a&scoped=true&"
import script from "./PageInspiration.vue?vue&type=script&lang=js&"
export * from "./PageInspiration.vue?vue&type=script&lang=js&"
import style0 from "./PageInspiration.vue?vue&type=style&index=0&id=cdf9b47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf9b47a",
  null
  
)

component.options.__file = "PageInspiration.vue"
export default component.exports